import { ComputedRef, InjectionKey, Ref } from 'vue';

import type { ResolvedPopulationSegmentType } from '@/components/reports/AccountMappingFiltersPopulationsHover.vue';

import useReportState from '@/composables/reports/useReportState';
import { CROSSBEAM_SOURCE } from '@/constants/reports';
import { OpportunityItem, PartnerSourcesItem } from '@/types/reports';

export const ProvidedReportState: InjectionKey<
  Partial<ReturnType<typeof useReportState>>
> = Symbol('ProvidedReportState');

export const ProvidedUserAddedFilterLabels: InjectionKey<Ref<Set<string>>> =
  Symbol('ProvidedUserAddedFilterLabels');

export const ProvidedOppDataCache: InjectionKey<
  Ref<Record<string, OpportunityItem[]>>
> = Symbol('ProvidedOppDataCache');

export const ProvidedReportCrossbeamFilters: InjectionKey<{
  filteredCrossbeamSource: ComputedRef<typeof CROSSBEAM_SOURCE>;
  isAccountMappingReport: ComputedRef<boolean>;
  isEcosystemReport: ComputedRef<boolean>;
}> = Symbol('ProvidedReportCrossbeamFilters');

export const ProvidedRetrievedReportPartnerSources: InjectionKey<
  ComputedRef<PartnerSourcesItem[]>
> = Symbol('ProvidedRetrievedReportPartnerSources');

export const ProvidedResolvedOurSegments: InjectionKey<
  ComputedRef<ResolvedPopulationSegmentType[]>
> = Symbol('ProvidedResolvedOurSegments');

export const ProvidedResolvedPartnerSegments: InjectionKey<
  ComputedRef<ResolvedPopulationSegmentType[]>
> = Symbol('ProvidedResolvedPartnerSegments');
